import { GetVideoThumbnailsByIds_Query } from 'apollo/queries';
import { watchAsyncBatchedQuery, watchAsyncQuery } from 'helpers/saga/effects';
import { all } from 'redux-saga/effects';

import type { FetchVideoThumbnailParams } from './thumbnail-slice';
import {
  createTransformKey,
  fetchVideoThumbnailAC,
  fetchVideoThumbnailsByIdsAC,
} from './thumbnail-slice';

export default function* thumbnailSaga() {
  yield all([
    watchAsyncQuery(
      fetchVideoThumbnailsByIdsAC,
      GetVideoThumbnailsByIds_Query,
      ['videos'],
    ),
    watchAsyncBatchedQuery(
      50,
      fetchVideoThumbnailAC,
      fetchVideoThumbnailsByIdsAC,
      (params: FetchVideoThumbnailParams[]) => ({
        ids: params.map((p) => p.videoId),
        transform: params[0]?.transform,
      }),
      ({ payload }) => createTransformKey(payload.transform),
    ),
  ]);
}
